import { AxiosResponse } from 'axios';
import { httpService } from 'core-utilities';
import experimentConstants from '../constants/experimentConstants';

const getExperimentationValues = async <T extends Record<string, number | string | boolean>>(
  layerName: string,
  defaultValues: T,
  projectId = 1
): Promise<T> => {
  try {
    const { data } = ((await httpService.get(
      experimentConstants.url.getExperimentationValues(
        projectId,
        layerName,
        Object.keys(defaultValues)
      )
    )) as unknown) as AxiosResponse<T>;
    const parsedData = Object.keys(data).reduce<Record<string, any>>((acc, item) => {
      if (data[item] !== null) {
        acc[item] = data[item];
      }
      return acc;
    }, {});
    return { ...defaultValues, ...parsedData };
  } catch {
    return defaultValues;
  }
};

export default {
  getExperimentationValues
};
